import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_150: FaireProductEntity = {
  token: "legacy_prod_abbott-150",
  type: "product",
  name: "Chipmunk Door Wedge-Dark Brown",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0b43629e766fc98e9ded271052e462568a8c8dd319da5a8499b6f915bba19de7.jpeg",
  priceDollars: 24,
  subcategory: "Outdoor Decor",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
